module.exports = __webpack_public_path__ + "img/kw.svg";